<template>
  <div
    class="footer-banner px-2"
    style="width:100%;"
  >
    <div class="row">
      <div>
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="$emit('hide')"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'GlobalSearchMultipleResultFooter'
}
</script>

<style>
</style>
